import React, { useRef } from "react";
import styles from "./styles.module.scss";
import { motion, MotionValue, useScroll, useTransform } from "framer-motion";
import { ButtonTypes } from "../../../../Shared/types/campaigns";

export function useParallax(value: MotionValue<number>, distance: number) {
	return useTransform(value, [0, 1], [`${-distance}%`, `${distance}%`]);
}

export function useOpacity(value: MotionValue<number>) {
	return useTransform(value, [0.7, 1], [0.9, 1]);
}

function useClampedPosition(value: MotionValue<number>) {
	return useTransform(value, [0, 1], ["-300px", "0"]);
}

export function useContainerOpacity(value: MotionValue<number>) {
	return useTransform(value, [0, 1], [0, 1]);
}

const Buttons = ({ buttons }: { buttons: ButtonTypes[] }) => {
	if (!buttons || !buttons.length) {
		return null;
	}

	return (
		<div className="cta">
			{buttons.map((button, i) => {
				return (
					<React.Fragment key={i}>
						{button.type === "button" && <a href={button.buttonLink.url}>{button.buttonLink.text}</a>}
						{button.type === "brochure" && <a href={button.brochureAsset.url}>{button.brochureAsset.text}</a>}
					</React.Fragment>
				);
			})}
		</div>
	);
}

type MovableLayerProps = { scrollYProgress: MotionValue<number> };
type MovableLayerType = (props: MovableLayerProps) => JSX.Element;

// type MovableLayerType = ({ scrollYProgress }: ) => React.ReactNode;

export default function Models({
	description,
	title,
	background,
	buttons = [],
	MovableLayer = null
}: {
	MovableLayer?: MovableLayerType,
	buttons?: ButtonTypes[],
	title: string,
	description: string,
	background: string
}) {
	const ref = useRef(null);

	const { scrollYProgress }: { scrollYProgress: MotionValue<number> } = useScroll({
		target: ref,
		offset: ["start end", "end end"],
		smooth: 100
	});

	const pos = useClampedPosition(scrollYProgress);
	const opacity = useContainerOpacity(scrollYProgress);

	return (
		<motion.div
			ref={ref}
			className={styles.wrapper}
			style={{ y: pos, opacity }}
			transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
		>
			<div className={styles.section} style={{
				backgroundImage: `url("${background}")`,
			}}>
				<div className="customContainer">
					{MovableLayer && <MovableLayer scrollYProgress={scrollYProgress} />}
					<div className="right">
						<h3>{title}</h3>
						<div dangerouslySetInnerHTML={{ __html: description }} />
						<Buttons buttons={buttons} />
					</div>
				</div>
			</div>
		</motion.div>
	);
}